import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const DragHandleIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M11 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M11 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM11 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM16 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
              }
            )
          ]
        }
      );
    }
    console.error(
      `DragHandleIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { DragHandleIcon };
//# sourceMappingURL=DragHandleIcon.mjs.map
